import axios from "axios";
import { openCommonAlert } from "bodycodi/cmap/app/js/common.js";

const url = process.env.REACT_APP_API;
const API_KEY = process.env.REACT_APP_API_KEY;

export const api = axios.create({
  baseURL: "/api",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-API-KEY": API_KEY,
  },
  withCredentials: true,
});

export async function catchErrorHandler(error) {
  console.log(error.response);
  const { status, data } = error.response;
  if (data.errorCode === "A00003" || data.errorCode === "A00002" || data.errorCode === "A00007") {
    openCommonAlert({
      header: "오류발생",
      body: `다시 로그인해주세요`,
      closeAlert: () => {
        removeLocalStorage();
        window.location = "/login";
      },
    });
  } else {
    openCommonAlert({
      header: "오류발생",
      body: `앗, 문제가 발생했어요.\n 관리자에게 문의해주세요.`,
    });
  }
  console.log(`${status} ${JSON.stringify(data?.message || data)}`);
  throw "";
}

export function removeLocalStorage() {
  window.localStorage.removeItem("accessToken");
  window.localStorage.removeItem("seqMobileMembers");
  window.localStorage.removeItem("seqManagerMobileDevice");
  return;
}

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

api.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.log(error.response);
    const { data, config: originalRequest } = error.response;

    // A00003 : Authorization 헤더가 존재하지 않습니다.
    if (data.errorCode === "A00003") {
      const accessToken = window.localStorage.getItem("accessToken");
      if (accessToken) {
        api.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
        originalRequest.headers["Authorization"] = `Bearer ${accessToken}`;
        return new Promise(function (resolve, reject) {
          resolve(api(originalRequest));
        });
      }
    }

    // A00002 : 토큰이 만료되었습니다.
    if (data.errorCode === "A00002") {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = `Bearer ${token}`;
            return api(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const seqMobileMembers = window.localStorage.getItem("seqMobileMembers");
      const seqManagerMobileDevice = window.localStorage.getItem("seqManagerMobileDevice");
      return new Promise(function (resolve, reject) {
        api
          .post("/cmap1010/re-issuance-token", {
            seqMobileMembers,
            seqManagerMobileDevice,
          })
          .then(({ data }) => {
            // 헤더에 전역으로 Authorization 적용
            api.defaults.headers.common["Authorization"] = `Bearer ${data.accessToken}`;
            // localstorage에 토큰 저장
            window.localStorage.setItem("accessToken", data.accessToken);
            processQueue(null, data.accessToken);
            originalRequest.headers["Authorization"] = `Bearer ${data.accessToken}`;
            resolve(api(originalRequest));
          })
          .catch((err) => {
            failedQueue = [];
            reject(err);
            removeLocalStorage();

            openCommonAlert({
              header: "오류발생",
              body: `다시 로그인해주세요`,
              closeAlert: () => {
                window.location = "/login";
              },
            });
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    }
    return Promise.reject(error);
  }
);

export const delayResponse = (delay) => {
  return (data) => {
    return new Promise((resolve) => setTimeout(() => resolve(data), delay));
  };
};

export const isDuplicateRequest = (timestamp, milliseconds) => {
  if (!timestamp) return false;
  const isDuplicate = Date.now() - timestamp < (milliseconds || 500);
  return isDuplicate;
};
